module.exports = __webpack_public_path__ + "media/welcome_1.15388a3c.mp3";